import React from 'react';
import FormConfigOptions from './FormConfigOptions';
import FormConfigRequired from './FormConfigRequired';
import FormConfigTitleDescription from './FormConfigTitleDescription';
const FormConfigMultiSelect = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(FormConfigTitleDescription, null),
        React.createElement(FormConfigRequired, null),
        React.createElement(FormConfigOptions, { multiselect: true })));
};
export default FormConfigMultiSelect;
//# sourceMappingURL=FormConfigMultiSelect.js.map